<template>
  <div class="doc-card">
    <a :href="url" target="_blank" rel="noopener" class="doc-card__main">
      <img :src="pdfIcon" class="doc-card__icon" alt="Документ"/>
      <span class="doc-card__info">
        <span class="doc-card__name">{{ name }}</span>
        <span v-if="meta" class="doc-card__meta">{{ meta }}</span>
      </span>
    </a>
    <a
        :href="url"
        :download="downloadName"
        rel="noopener"
        class="doc-card__action"
        aria-label="Скачать"
        title="Скачать"
        @click="onDownload"
    >
      <img :src="downloadIcon" alt=""/>
    </a>
  </div>
</template>

<script>
import pdfIcon from "@/assets/img/pdf.svg";
import downloadIcon from "@/assets/img/download.svg";

export default {
  name: "DocumentCard",
  props: {
    name: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    // необязательная подпись под названием (дата, размер и т.п.)
    meta: {
      type: String,
      default: "",
    },
  },
  data() {
    return { pdfIcon, downloadIcon };
  },
  computed: {
    // имя файла для сохранения: если в названии нет расширения — берём его из ссылки
    downloadName() {
      const urlName = this.url.split("?")[0].split("/").pop() || "";
      if (this.name && this.name.includes(".")) {
        return this.name;
      }
      const dot = urlName.lastIndexOf(".");
      const ext = dot > -1 ? urlName.slice(dot) : "";
      return this.name ? this.name + ext : urlName || this.name;
    },
  },
  methods: {
    async onDownload(event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
        return;
      }
      event.preventDefault();
      try {
        const response = await fetch(this.url, { credentials: "include" });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = this.downloadName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
      } catch (e) {
        console.error("DocumentCard: не удалось скачать файл, открываю в новой вкладке", e);
        window.open(this.url, "_blank", "noopener");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.doc-card {
  display: grid;
  grid-template-columns: 2.25rem 1fr auto;
  gap: 1rem;
  align-items: center;
  padding: 1rem 1.25rem;
  border: 1px solid var(--stroke-on-white-color);
  border-radius: 0.75rem;
  background: var(--white-color);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: rgba(0, 0, 0, 0.08);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  }

  @media (max-width: 575px) {
    grid-template-columns: 2rem 1fr auto;
    gap: 0.75rem;
    padding: 0.85rem 1rem;
  }
}

.doc-card__main {
  display: contents;
  color: inherit;
  text-decoration: none;
}

.doc-card__icon {
  width: 2.25rem;
  height: 2.25rem;
  object-fit: contain;

  @media (max-width: 575px) {
    width: 2rem;
    height: 2rem;
  }
}

.doc-card__info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.doc-card__name {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--font-dark-color);
  word-break: break-word;
}

.doc-card__meta {
  font-size: 0.8rem;
  color: var(--secondary-gray);
}

.doc-card__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  flex-shrink: 0;
  transition: background-color 0.2s ease;

  img {
    width: 1.5rem;
    height: 1.5rem;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
}
</style>
